module.exports = require("otpauth");